const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

type ApiOptions = RequestInit & { auth?: boolean };

function cookie(name: string) {
  const prefix = `${encodeURIComponent(name)}=`;
  return document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix))
    ?.slice(prefix.length);
}

export async function apiRequest<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const headers = new Headers(options.headers);
  const isFormData = options.body instanceof FormData;
  if (options.body && !isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const method = (options.method ?? "GET").toUpperCase();
  if (options.auth !== false && !["GET", "HEAD", "OPTIONS"].includes(method)) {
    const csrf = cookie("annecosette_csrf");
    if (csrf) headers.set("X-CSRF-Token", decodeURIComponent(csrf));
  }
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers,
    credentials: "include",
  });
  if (!response.ok) {
    let message = response.statusText || "Something went wrong";
    try {
      const body = (await response.json()) as { detail?: string };
      if (body.detail) message = body.detail;
    } catch {
      // Keep the HTTP status text when the body is not JSON.
    }
    throw new Error(message);
  }
  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}

export const storeQueries = {
  storefront: () => apiRequest<import("./types").Storefront>("/api/storefront", { auth: false }),
  products: (category?: string) =>
    apiRequest<import("./types").Product[]>(`/api/products${category ? `?category=${encodeURIComponent(category)}` : ""}`, { auth: false }),
  product: (slug: string) => apiRequest<import("./types").Product>(`/api/products/${encodeURIComponent(slug)}`, { auth: false }),
};

